module.exports = __webpack_public_path__ + "static/media/sign-in-koala.93652aae.png";